import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  /* We need to ensure that any image passed in as a child (<img/>, <svg/>\n  etc.) receives the correct width, height and border radius. We don\'t\n  currently assume that the image passed in is the correct dimensions, or has\n  width / height 100% */\n  & > img {\n    border-radius: ', 'px;\n    height: ', 'px;\n    width: ', 'px;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  /* We need to ensure that any image passed in as a child (<img/>, <svg/>\n  etc.) receives the correct width, height and border radius. We don\'t\n  currently assume that the image passed in is the correct dimensions, or has\n  width / height 100% */\n  & > img {\n    border-radius: ', 'px;\n    height: ', 'px;\n    width: ', 'px;\n  }\n']);

import styled from 'styled-components';
import { gridSize } from '../../shared-variables';

var size = gridSize * 5;
var borderRadius = 4;

var ContainerTitleIcon = styled.div(_templateObject, size, size, borderRadius, size, size);

ContainerTitleIcon.displayName = 'ContainerTitleIcon';
export default ContainerTitleIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/ContainerTitleIcon.js
// module id = 279
// module chunks = 0